import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Icon } from '@iconify/react';

const ConfirmationModal = ({
  show,
  onHide,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  variant = 'danger',
  icon = 'mdi:alert-circle',
  onConfirm,
  isLoading = false,
  loadingText = 'Processando...',
  size = 'md'
}) => {
  const getVariantConfig = () => {
    switch (variant) {
      case 'success':
        return {
          headerClass: 'bg-success text-white',
          iconClass: 'text-success',
          buttonVariant: 'success'
        };
      case 'warning':
        return {
          headerClass: 'bg-warning text-dark',
          iconClass: 'text-warning',
          buttonVariant: 'warning'
        };
      case 'info':
        return {
          headerClass: 'bg-info text-white',
          iconClass: 'text-info',
          buttonVariant: 'info'
        };
      default: // danger
        return {
          headerClass: 'bg-danger text-white',
          iconClass: 'text-danger',
          buttonVariant: 'danger'
        };
    }
  };

  const config = getVariantConfig();

  return (
    <Modal show={show} onHide={onHide} centered size={size}>
      <Modal.Header closeButton className={config.headerClass}>
        <Modal.Title>
          <Icon icon={icon} className="me-2" />
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="text-center">
          <Icon icon={icon} className={config.iconClass} style={{ fontSize: '2.5rem' }} />
          <h6 className="mt-3 mb-2">{title}</h6>
          <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
            {message}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="bg-light border-top">
        <Button variant="outline-secondary" onClick={onHide} disabled={isLoading}>
          <Icon icon="mdi:close" className="me-2" />
          {cancelText}
        </Button>
        <Button 
          variant={config.buttonVariant} 
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <div className="spinner-border spinner-border-sm me-2" role="status">
                <span className="visually-hidden">{loadingText}</span>
              </div>
              {loadingText}
            </>
          ) : (
            <>
              <Icon icon="mdi:check" className="me-2" />
              {confirmText}
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal; 